import { lazy } from 'react';

export const PlayerLossLimitsForm = lazy(
  () => import('./PlayerLossLimitsForm'),
);
